<template>
    <el-dialog title="已关联客户" :visible.sync="dialogTableVisible">
        <el-table :data="list" v-loading="loading">
            <el-table-column property="customer_name" label="客户名称"></el-table-column>
            <el-table-column property="username" label="业务员"></el-table-column>
            <el-table-column property="branch_name" label="所属部门"></el-table-column>
            <el-table-column label="操作"  fixed="right">
                <template slot-scope="scope">
                    <el-button @click="handleView(scope.row)" type="text"  size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
    </el-dialog>
</template>
<script>
    import ClueCount from "~/services/ClueCount";
    import MyPagination from "~/widgets/MyPagination.vue";
    export default {
        props:{
            params:{
                type: Object,
                required: true,
            },
        },
        components: {
            MyPagination
        },
        data(){
            return {
                list:[],
                loading: false,
                dialogTableVisible: true,
                linkPage: null,
            }
        },
        created() {
            this.getList();
        },
        methods: {
            //获取列表
            getList() {
                // loading 动画
                this.loading = true;
                ClueCount.getList(this.params, 'bind-customer-table')
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            },

            handleView(row) {
                let routeData = this.$router.resolve({
                    path: "/customers/view",
                    query: { id: row.customer_id },
                });
                window.open(routeData.href, '_blank');
            },

            handleSizeChange(newSize) {
                // 处理每页条目数变化事件
                let params = this.params;
                params['perPage'] = newSize;
                this.getList(params);
            },

            handleCurrentChange(newPage) {
                let params = this.params;
                // 处理当前页码变化事件
                params['page'] = newPage;
                this.getList(params);
            },
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/clue/dialog/customerListDialog.vue